// Environment configuration interface
interface EnvironmentConfig {
    EnvironmentLabel: string;
    SignalRUrl: string;
    WebApiUrl: string;
}

// Keys of ENVIRONMENT_CONFIG. Naming these ties the matcher table and the config table together, so
// a matcher pointing at an environment that has no config entry is a compile error rather than an
// undefined lookup at runtime.
type EnvKey = "DEV" | "QAT" | "UAT" | "STG" | "PROD" | "UAT_AUS" | "PROD_AUS";

// Web hostname matchers - order matters (first match wins)
const HOST_MATCHERS: Array<{ match: (host: string, port: string) => boolean; env: EnvKey }> = [
    { match: (h) => h.startsWith("companion-uat.") && h.endsWith(".auggie.airprodiag.com.au"), env: "UAT_AUS" },
    { match: (h) => h.endsWith(".auggie.airprodiag.com.au"), env: "PROD_AUS" },
    { match: (h) => h.startsWith("companion-qat."), env: "QAT" },
    { match: (h) => h.startsWith("companion-uat."), env: "UAT" },
    { match: (h) => h.startsWith("companion-stg."), env: "STG" },
    { match: (h) => h.startsWith("companion."), env: "PROD" },
    { match: (h, p) => h === "localhost" && p === "44343", env: "DEV" },
];

// Environment configuration table
const ENVIRONMENT_CONFIG: Record<EnvKey, EnvironmentConfig> = {
    DEV: {
        EnvironmentLabel: "Development Environment",
        SignalRUrl: "http://localhost:7174/api",
        WebApiUrl: "https://localhost:44360/",
    },
    QAT: {
        EnvironmentLabel: "Quality Assurance Testing Environment",
        SignalRUrl: "https://api-qat.auggie.tech/signalr",
        WebApiUrl: "https://api-qat.auggie.tech/companion/",
    },
    UAT: {
        EnvironmentLabel: "User Acceptance Testing Environment",
        SignalRUrl: "https://api-uat.auggie.tech/signalr",
        WebApiUrl: "https://api-uat.auggie.tech/companion/",
    },
    STG: {
        EnvironmentLabel: "",
        SignalRUrl: "https://api-stg.auggie.tech/signalr",
        WebApiUrl: "https://api-stg.auggie.tech/companion/",
    },
    PROD: {
        EnvironmentLabel: "",
        SignalRUrl: "https://api.auggie.tech/signalr",
        WebApiUrl: "https://api.auggie.tech/companion/",
    },
    UAT_AUS: {
        EnvironmentLabel: "User Acceptance Testing Environment",
        SignalRUrl: "https://api-uat.auggie.airprodiag.com.au/signalr",
        WebApiUrl: "https://api-uat.auggie.airprodiag.com.au/companion/",
    },
    PROD_AUS: {
        EnvironmentLabel: "",
        SignalRUrl: "https://api.auggie.airprodiag.com.au/signalr",
        WebApiUrl: "https://api.auggie.airprodiag.com.au/companion/",
    },
};

export class Globals {

    private static cachedEnvKey: EnvKey | null = null;

    private static getEnvKey(): EnvKey {
        if (this.cachedEnvKey) return this.cachedEnvKey;

        const host = globalThis.location.hostname;
        const port = globalThis.location.port;
        for (const { match, env } of HOST_MATCHERS) {
            if (match(host, port)) {
                this.cachedEnvKey = env;
                return env;
            }
        }
        throw new Error(`Unknown host: ${host}`);
    }

    private static getConfig(): EnvironmentConfig {
        return ENVIRONMENT_CONFIG[this.getEnvKey()];
    }

    public static GetEnvironment(): string {
        return this.getConfig().EnvironmentLabel;
    }

    public static GetSignalRFunction(): string {
        return this.getConfig().SignalRUrl;
    }

    public static GetWebApi(): string {
        return this.getConfig().WebApiUrl;
    }
}
export default Globals;
